import CONSTANTS from "./constants";

export const setPageHeadingAction = (payload = "") => {
  return {
    type: CONSTANTS.LAYOUT_PAGE_HEADING,
    payload,
  };
};

export const toggleHeaderScrollEffectAction = (payload) => {
  return {
    type: CONSTANTS.LAYOUT_SCROLL_TOGGLE,
    payload,
  };
};
export const pullDownRefreshEventAction = (payload) => {
  return {
    type: CONSTANTS.LAYOUT_PULL_DOWN_REFRESH,
    payload,
  };
};
export const pullDownRefreshEventReleaseAction = (payload) => {
  return {
    type: CONSTANTS.LAYOUT_PULL_DOWN_REFRESH_RELEASE,
    payload,
  };
};

export const toggleFooterSuggestionsAction = (payload) => {
  return {
    type: CONSTANTS.LAYOUT_SHOW_SUGGESTIONS,
    payload,
  };
};

export const setUserDetailsInfoAction = (payload) => {
  return {
    type: CONSTANTS.LAYOUT_USER_DETAILS_INFO,
    payload,
  };
};

export const buyNowDoubtBuddyModalAction = (payload) =>({
  type: CONSTANTS.BUYNOW_DOUBT_BUDDY_MODAL,
  payload
})
